import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "text-center my-4" }
const _hoisted_2 = {
  key: 0,
  class: "mb-2 text-subtitle-1 font-weight-medium"
}
const _hoisted_3 = {
  key: 0,
  style: {"width":"100%","height":"500px"}
}

import { ref, watch } from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageCropper',
  props: {
    modelValue: {},
    label: {},
    aspectRatio: {}
  },
  emits: ['update:modelValue', 'change'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const image = ref<string | null>(null);
const selectedFile = ref<File | null>(null);
const dialog = ref(false);
const cropperRef = ref<InstanceType<typeof Cropper> | null>(null);
const fileInput = ref<HTMLInputElement | null>(null);
const cropped = ref<string | null>(props.modelValue || null);

watch(
  () => props.modelValue,
  (newVal) => {
    cropped.value = newVal;
  }
);

watch(cropped, (newVal) => {
  emit('update:modelValue', newVal);
});

const onFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    selectedFile.value = target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      image.value = event.target?.result as string;
      dialog.value = true;
    };
    reader.readAsDataURL(target.files[0]);
  }
};

const cropImage = () => {
  if (cropperRef.value) {
    const { canvas } = cropperRef.value.getResult() as { canvas: HTMLCanvasElement };
    const base64 = canvas.toDataURL('image/png');
    cropped.value = base64;

    const croppedFile = base64ToFile(base64, selectedFile.value?.name || 'cropped.png');
    emit('change', base64, croppedFile);
  }
  dialog.value = false;
};

function base64ToFile(base64: string, filename: string): File {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

const selectNewImage = () => {
  fileInput.value?.click();
};

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      accept: "image/*",
      onChange: onFileChange,
      style: {"display":"none"}
    }, null, 544),
    (cropped.value)
      ? (_openBlock(), _createBlock(_component_v_img, {
          key: 1,
          src: cropped.value,
          width: props.aspectRatio === 1 ? '180' : '300',
          height: 180,
          rounded: props.aspectRatio === 1 ? 'circle' : false,
          class: "mx-auto cursor-pointer elevation-2",
          onClick: selectNewImage,
          cover: ""
        }, null, 8, ["src", "width", "rounded"]))
      : (props.aspectRatio === 1)
        ? (_openBlock(), _createBlock(_component_v_avatar, {
            key: 2,
            size: "140",
            class: "mx-auto cursor-pointer elevation-2",
            color: "grey-lighten-3",
            onClick: selectNewImage
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "48" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-camera", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "mx-auto cursor-pointer elevation-2 d-flex align-center justify-center",
            style: {"width":"300px","height":"180px","background-color":"#f5f5f5","border":"1px dashed #ccc"},
            onClick: selectNewImage
          }, [
            _createVNode(_component_v_icon, {
              size: "48",
              color: "grey"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-camera", -1)
              ]))]),
              _: 1
            })
          ])),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
      "max-width": "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6 font-weight-medium" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Crop Image", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (image.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(Cropper), {
                        ref_key: "cropperRef",
                        ref: cropperRef,
                        src: image.value,
                        "stencil-props": { aspectRatio: props.aspectRatio || 1 },
                        class: "border rounded-md overflow-hidden",
                        style: {"width":"100%","height":"100%"}
                      }, null, 8, ["src", "stencil-props"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  color: "secondary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: cropImage
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("Crop", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})